module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Binnie Kirshenbaum\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Binnie Kirshenbaum is the author of "), _c('I', [_vm._v("An Almost Perfect Moment, On Mermaid Avenue, A Disturbance in One Place, Pure Poetry, Hester Among the Ruins,")]), _vm._v(" and "), _c('I', [_vm._v("History on a Personal Note.")]), _vm._v(" She is a professor at Columbia University's School of the Arts, where she is chair of the Graduate Writing Program.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yidfTT/tc-custom/9780061972706.jpg?1725288189179",
      "alt": "This image is the cover for the book Almost Perfect Moment"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Almost Perfect Moment\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In Brooklyn, in the Age of Disco, Valentine Kessler -- a sweet Jewish girl who bears a remarkable resemblance to the Virgin Mary of Lourdes -- has an unerring gift for shattering the dreams and hopes of those who love her. Miriam, her long-suffering mother, betrayed and anguished by the husband she adores, seeks solace in daily games of mah-jongg with The Girls, a cross between a Greek Chorus and Brooklyn's rendition of the Three Wise Men, who dispense advice, predictions, and care in the form of poppy-seed cake and apple strudels. When her greatest fear for Valentine is realized, Miriam takes comfort in the thought that it couldn't get any worse. And then it does.")]), _c('p', [_vm._v("Sagacious, sorrowful, and hilarious, "), _c('i', [_vm._v("An Almost Perfect Moment")]), _vm._v(" is a novel about mothers and daughters, star-crossed lovers, doctrines of the divine, and a colorful Jewish community that once defined Brooklyn.")]), _c('p', [_vm._v("This P.S. edition features an extra 16 pages of insights into the book, including author interviews, recommended reading, and more.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0